module.exports = __webpack_public_path__ + "img/fuente_de_alimentacion_ininterrumpida.28ff0416.jpg";